import { gql } from "gql";

export const GET_NOTIFICATION_TEMPLATE = gql(/* GraphQL */ `
  query GetNotificationTemplate($id: ID!) {
    getNotificationTemplateById(id: $id) {
      id
      code
      properties
      value {
        ...EditNotificationTemplate
      }
    }
  }
`);
